// ExportInvitesPDF.jsx
import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image
} from '@react-pdf/renderer';

import websitelogo from "../../../../assets/websitelogo.png";
import websitelogoes from "../../../../assets/websitelogoes.png";
import { useTranslation } from 'react-i18next';

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: 'Helvetica',
    color: '#101828'
  },

  heading: {
    textAlign: 'center',
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 20,
    color: '#003149'
  },
  recordGroup: {
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    borderBottomStyle: 'solid'
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8
  },
  label: {
    color: '#344054',
    fontWeight: 'bold'
  },
  value: {
    color: '#101828'
  }
});

const ExportInvitesPDF = ({ data }) => {
  const { t, i18n } = useTranslation();

  // if language = es → show es logo, otherwise show english logo
  const logoToUse = i18n.language === "es" ? websitelogo : websitelogoes;

  const formatSubscription = (value) => {
  if (!value) return "";

  return value
    .replace(/_/g, " ")             // full_monthly → full monthly
    .replace(/\b\w/g, (c) => c.toUpperCase()); // Full Monthly
};

  return (
    <Document>
      <Page size="A4" style={styles.page}>

        {/* Dynamic logo */}
        <Image src={logoToUse}  style={{ width: 120, alignSelf: "center", marginBottom: 20 }} />

        {/* Dynamic heading */}
        <Text style={styles.heading}>    {t('invites.manageTitle')}</Text>

        {data.map((item, index) => (
          <View key={index} style={styles.recordGroup}>
            
            <View style={styles.row}>
              <Text style={styles.label}>{t('invites.columns.id')}:</Text>
              <Text style={styles.value}>{item.id}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t('invites.columns.admin')}:</Text>
              <Text style={styles.value}>{item.admin}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t('invites.columns.email')}:</Text>
              <Text style={styles.value}>{item.email}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t('invites.columns.company')}:</Text>
              <Text style={styles.value}>{item.company}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t('invites.columns.country')}:</Text>
              <Text style={styles.value}>{item.country}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t('invites.columns.subscription')}:</Text>
              <Text style={styles.value}>{item.subscription ? formatSubscription(item.subscription) : '-'}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t('invites.columns.status')}:</Text>
              <Text style={styles.value}>{item.status}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t('invites.columns.date')}:</Text>
              <Text style={styles.value}>{item.date}</Text>
            </View>

          </View>
        ))}
      </Page>
    </Document>
  );
};

export default ExportInvitesPDF;
